import { useMemo } from 'react'
import { ScrollToContent } from '../store/scrollStore'

/**
 * Hook responsible for validating scroll request data
 * Single Responsibility: Input validation and data extraction
 * @param {ScrollToContent} scrollToContent - The content to scroll to
 * @returns {Object} - Contains scrollToId, correspondingTrackChange, and isRequestValid
 */
export const useScrollRequestValidator = (scrollToContent: ScrollToContent) => {
    const { id: scrollToId, correspondingTrackChange } = useMemo(
        () =>
            scrollToContent || { id: '', correspondingTrackChange: undefined },
        [scrollToContent]
    )

    const isRequestValid = useMemo(
        () => Boolean(scrollToId && correspondingTrackChange),
        [scrollToId, correspondingTrackChange]
    )

    return {
        scrollToId,
        correspondingTrackChange,
        isRequestValid,
    }
}
